import i18n from "@/libs/i18n";
import {
  ref,
  reactive,
  computed,
  onBeforeMount,
  getCurrentInstance,
  watch,
} from "@vue/composition-api";

export default function useSetTimeInterval() {
  // 60000 millisecond = 1 minute
  const onSetTimeInterval = async (callback, ms = 60000) => {
    return new Promise((resolve, reject) => {
      const interval = setInterval(async () => {
        if (await callback()) {
          resolve();
          clearInterval(interval);
        }
      }, ms);
    });
  };

  return { onSetTimeInterval };
}
